export default function OurValues() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Uncompromising Quality',
      description: 'Every product is tested on real job sites before it reaches your hands.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Built for South Africa',
      description: 'Formulated for local conditions: humidity, temperature, substrate.',
    },
    {
      icon: 'ri-team-line',
      title: 'Trade Partnership',
      description: "We don't just sell product. We support the builders, tilers and contractors who rely on us.",
    },
  ];

  return (
    <section className="py-12 md:py-24 px-4 md:px-8 bg-gray-50 overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <h2
          className="text-2xl md:text-4xl font-bold text-center mb-12"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          What We Stand For
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-[#1A1A1A] rounded-lg p-8 text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i
                  className={`${value.icon} text-5xl`}
                  style={{ color: '#F2C612' }}
                ></i>
              </div>
              <h3
                className="text-xl font-bold mb-4 text-white"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                {value.title}
              </h3>
              <p className="text-gray-300 text-sm md:text-base">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}